<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <form @submit.prevent="correctEvent">
                    <div class="form-group">
                        <label class="text-white" for="id">Evento-ID</label>
                        <input type="text" class="form-control" id="id" v-model="id" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="opcao-id">Opção-ID</label>
                        <select id="opcao-id" class="form-control" v-model="opcao_id" required>
                            <option value="" selected>Selecione uma opção</option>
                            <option v-for="(item, index) in markets" :value="item.id" :key="index">
                               {{marketGetSport(item.id)}} | ({{item.cat.toString().toUpperCase()}}) | {{item.label}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="odd">Cotação</label>
                        <input type="text" class="form-control" id="odd" v-model="odd" :readonly="block" autocomplete="off" spellcheck="false" v-number-only required>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-block btn-success" :disabled="block">
                                <i class="fas fa-save mr-2"></i>Salvar
                            </button>
                        </div>
                        <div class="col">
                            <a class="btn btn-block btn-danger" @click="cancel" :class="{'disabled': block}">
                                <i class="fas fa-ban mr-2"></i>Cancelar
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            id: '',
            odd: '',
            opcao_id: '',
            markets: [],
            block: true,
            loading: false,
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        correctEvent() {

            const self = this;
            
            if (self.id.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o evento-ID!',
                    'warning'
                );
            } else if (self.opcao_id.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a opção-ID!',
                    'warning'
                );
            } else if (self.odd.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a cotação!',
                    'warning'
                );
            } else {

                self.loading = true;

                api.post('betting-correction-odd', {
                    id: self.id,
                    odd: self.odd,
                    option: self.opcao_id
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.report(response.data.results);
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        report(results) {
            
            let html = '';
            let count = 0;

            this.cancel();
            
            for (const item of results) {

                html += `
                    <div class="row pb-3 border-bottom ${count > 0 ? 'pt-3' : ''}">
                        <div class="col text-truncate">${item.cliente}</div>
                        <div class="col text-truncate ${(item.message.includes('erro') || item.message.includes('failed')) ? 'text-danger' : 'text-success'}">${item.message}</div>
                    </div>
                `; count++;
            }

            Swal.fire(
                `Relatório (${count})`,
                html
            );
        },
        cancel() {
            this.id = '';
            this.odd = '';
            this.opcao_id = '';
        },
        marketGetSport(id) {

            var sport = 1;

            if (id >= 1 && id <= 211) {
                sport = 'Futebol';
            } else if (id >= 212 && id <= 220) {
                sport = 'Basquete';
            } else if (id >= 221 && id <= 223) {
                sport = 'Lutas';
            } else if (id >= 224 && id <= 226) {
                sport = 'Hóquei';
            } else if (id >= 227 && id <= 229) {
                sport = 'Voleibol';
            } else if (id >= 230 && id <= 232) {
                sport = 'Tênis';
            } else if (id >= 233 && id <= 235) {
                sport = 'E-Sports';
            }

            return sport;
        }
    },
    directives: {
        numberOnly: {
            bind: (el) => {
                el.handler = () => {
                    el.value = el.value.replace(/\D/g,"").replace(/[0-9]{12}/," ").replace(/(\d{1})(\d{8})$/,"$1.$2").replace(/(\d{1})(\d{5})$/,"$1.$2").replace(/(\d{1})(\d{1,2})$/,"$1.$2").replace(',','.');
                }
                el.addEventListener('input', el.handler)
            },
            unbind: (el) => {
                el.removeEventListener('input', el.handler)
            }
        }
    },
    watch: {
        id(value) {
            this.id = value.replace(/[^a-zA-Z0-9]+/gi,'');
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {

        const self = this;

        self.loading = true;

        api.get('get-odds').then((response) => {
            switch(response.data.result) {
                case 'success':
                    self.markets = response.data.markets;
                break;
                default:
                    Swal.fire(
                        'Atenção!',
                        response.data.message,
                        'warning'
                    );
                break;
            }
        }).catch((error) => {
            try {
                Swal.fire(
                    'Falha',
                    self.network_erros[error.status]['message'],
                    'warning'
                );
            } catch(e) {
                Swal.fire(
                    'Falha',
                    self.network_erros[408]['message'],
                    'warning'
                );
            }
        }).finally(() => {
            self.loading = false;
        });
    }
}
</script>